<template>
  <inventoryProductsForm :typeEndPoint="'inventoryProductsShow'" :dataParams="this.$route.params" />
</template>
<script>
import inventoryProductsForm from '@/components/modules/inventory/products/form'
export default {
  name: 'inventoryProductsEdit',
  components: {
    inventoryProductsForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/products/edit.vue